/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useRef } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Box,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { GContextTypes } from '../../types';
import { GlobalContext } from '../../contexts';
import { useReactToPrint } from 'react-to-print';
import { CustomerClearancePrint } from '../../print';
import PrintDownloadCustomer from './PrintDownloadCustomer';
import { formTypeTitles, parseCustomerFormNote } from './customerFormMeta';

const PopupCustomerFormView = ({
  open,
  onClose,
  row,
  theme,
  company,
  customers,
  formType,
}: any) => {
  const {
    translate: { isRTL },
  }: GContextTypes = useContext(GlobalContext);

  const componentRef: any = useRef();
  const handleReactPrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Customer Form #${row?.docNo}`,
    removeAfterPrint: true,
  });

  if (!row) return null;

  const customer = customers?.find((c: any) => c._id === row.customerId);
  const formMeta = parseCustomerFormNote(row.note);

  const printData = {
    ...row,
    customer,
    custvalue: customer,
    contractDate: row?.startDate,
    formType,
    formMeta,
    isRTL,
  };

  const getTitle = () => {
    if (isRTL) {
      return formTypeTitles?.[formType]?.ar || 'مخالصة عميل';
    }

    return formTypeTitles?.[formType]?.en || 'Customer Clearance';
  };

  const title = `${getTitle()} #${row?.docNo}`;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: 10,
        },
      }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <span>{title}</span>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <PrintDownloadCustomer
          company={company}
          printData={printData}
          componentRef={componentRef}
          handleReactPrint={handleReactPrint}
          isRTL={isRTL}
          no={row?.docNo}
          isNew={false}
        />
        <Box mt={2}>
          <CustomerClearancePrint
            company={company}
            printData={printData}
            ref={componentRef}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PopupCustomerFormView;
